// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
// import iView from 'view-design'
import axios from "axios";
import store from "./store/store"; // 本地存储
import "view-design/dist/styles/iview.css";
// import Api from './api/index.js'
import "../static/js/axios.js";
import htmlToPdf from "../static/js/html2Pdf";
import Common from "../static/js/common";
import i18n from "./i18n/i18n";
import "babel-polyfill";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import VueClipboard from "vue-clipboard2";
import { TabContainer, TabContainerItem } from "mint-ui";
// import cookie from '../static/js/cookie'
// import $ from 'jquery'

Vue.component(TabContainer.name, TabContainer);
Vue.component(TabContainerItem.name, TabContainerItem);
Vue.prototype.common = Common;
Vue.prototype.$Message.config({
  // top: 500,
  duration: 3
});
// Vue.prototype.$api = Api;
// Vue.use(iView);
Vue.use(ElementUI);
Vue.use(htmlToPdf);
// Vue.use(i18n);
Vue.use(VueClipboard);

Vue.config.productionTip = false;
axios.defaults.headers.post["Content-Type"] = "application/json";
Vue.prototype.$http = axios;

axios.defaults.baseURL = process.env.API_ROOT;
let bus = new Vue();
Vue.prototype.bus = bus;
/* eslint-disable no-new */

let _vue = new Vue({
  el: "#app",
  router,
  store,
  i18n,
  components: { App },
  template: "<App/>"
});

document.title = _vue.$i18n.messages[_vue.$i18n.locale].title;



// WEBPACK FOOTER //
// ./src/main.js